/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentCreateMutationRequest, ContentCreateMutationResponse } from "../models/ContentCreate";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { contentCreate } from "../axios/contentCreate";
import { useMutation } from "@tanstack/react-query";

export const contentCreateMutationKey = () => ["content-ai-api", { url: '/contents' }] as const

export type ContentCreateMutationKey = ReturnType<typeof contentCreateMutationKey>

/**
 * @summary Create content
 * {@link /contents}
 */
export function useContentCreate<TContext>(options: 
{
  mutation?: UseMutationOptions<ContentCreateMutationResponse, ResponseErrorConfig<Error>, {data: ContentCreateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ContentCreateMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? contentCreateMutationKey()

  return useMutation<ContentCreateMutationResponse, ResponseErrorConfig<Error>, {data: ContentCreateMutationRequest}, TContext>({
    mutationFn: async({ data }) => {
      return contentCreate(data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}